import React, { useState } from "react";
import {
  FaDesktop,
  FaMobileAlt,
  FaAndroid,
  FaShoppingCart,
  FaUserTie,
  FaGlobe,
} from "react-icons/fa";
import oders_image from "../../../assets/Docs/orders_image (2).png";
import seller_orders  from '../../../assets/AppImages/seller_orders.png'
import { TagComponent } from "../Tabs";

const Orders = () => {
  const [activeTab2, setActiveTab2] = useState("web");

  const tabs = [
    { id: "web", label: "Web App", icon: <FaDesktop /> },
    {
      id: "mobile",
      label: "Mobile App",
      icon: <FaMobileAlt />,
      disabled: true,
    },
  ];

  console.log(activeTab2);



  const renderTabs = (activeState, setActiveState) => (
    <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveState(tab.id)}
          className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
            ? "bg-[#1a9588] text-white shadow"
            : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
            }`}

        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

      <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
        <FaShoppingCart className="text-4xl text-theme-logo-color mr-3" />
        <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">Orders</h1>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
          <TagComponent icon={<FaShoppingCart />} label="Buyer" color="pink" />
        </div>
        <div className="flex flex-wrap gap-3">
          <TagComponent icon={<FaGlobe />} label="Web" color="green" />
          <TagComponent icon={<FaAndroid />} label="Android" color="green" />
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-2xl mb-10">
        <p className="text-gray-700 text-start text-base leading-relaxed ">
          Orders are at the heart of the Selzor App. It provides a flexible
          platform for managing B2B orders—allowing you to place and receive
          orders without handling payments. Using the same login, you can act as
          both a ‘Seller’ (to receive orders) and a ‘Buyer’ (to place orders).
        </p>
      </div>


      <div className="">
        {renderTabs(activeTab2, setActiveTab2)}

        {activeTab2 === "web" ? (
          <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">
            <img
              src={oders_image}
              alt={`view`}
              className="rounded-xl max-w-full h-auto object-contain"
            />
          </div>
        ) : (
          <div className="rounded-xl p-4 sm:p-6  bg-gray-50 border border-gray-200 shadow-sm hover:shadow-md transition">
            <img
              src={seller_orders}
              alt={`view`}
              className="rounded-xl max-w-full h-auto object-contain"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Orders;
